
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-qgis_vector_style",
  "use": "icon-rescls-qgis_vector_style-usage",
  "viewBox": "-467 269 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-467 269 24 24\" id=\"icon-rescls-qgis_vector_style\"><path fill=\"#1face5\" d=\"M-457.8 285.7c.1 0 1-.6 1-.6l-1.2-4.6c-1 1.3-1.6 1.9-2 3.2zm10.9-12.2c.1.1.2.1.3.2.9-1.2 1.4-2 1.4-2s.3-.4 0-.7c-.4-.4-.9-.1-.9-.1s-1.1.8-2.5 1.8h.1c.6.2 1.1.5 1.6.8\" /><path fill=\"#00b066\" d=\"M-460.6 284c-5.6.5-3.2 5.4-6.4 7 4.2 0 8.5-.8 8.7-4.7-.1-.2-2.3-2.3-2.3-2.3\" /><path fill=\"#106a90\" d=\"M-446.2 288.3c-.5 0-.5-.5-.5-.5v-.9c2.2-1.5 3.7-4.1 3.7-7.1 0-4.7-3.6-8.4-8-8.4s-8 3.8-8 8.4 3.6 8.4 8 8.4c.5 0 .9-.1 1.4-.1v.2c0 1.7 1.3 2.3 2.9 2.3 1.7 0 3.8-.8 3.7-3.7-1.1 1.5-2.6 1.4-3.2 1.4m-4.8-16.2c1.7 0 3.1 3.5 3.1 7.7 0 1-.1 1.9-.2 2.7-2.3-1.4-5.2-.7-5.9-.2-.1-.8-.2-1.6-.2-2.5.1-4.2 1.5-7.7 3.2-7.7m0 15.5c-1.3 0-2.4-2-2.9-4.8 1.7-.8 3-.5 3.7-.2.6.3.6.8.6.8v3.4c-.5.5-.9.8-1.4.8\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-qgis_vector_style"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-qgis_vector_style";

        export default Icon;
    